import BaseAPI from "../base";

class LeXiangService extends BaseAPI {
  // 防癌险-服务信息查询
  fangaixianServiceDataSearch(params) {
    return this.post({
      url: "/YuanHe/Work/Fangaixian_ServiceDataSearch",
      data: params,
    });
  }

  // 防癌险-服务信息添加
  fangaixianServiceDataAdd(params) {
    return this.post({
      url: "/YuanHe/Work/Fangaixian_ServiceDataAdd",
      data: params,
    });
  }

  // 防癌险-标签状态查询
  fangaixianLabelStatusSearch(params) {
    return this.post({
      url: "/YuanHe/Work/Fangaixian_LabelStatusSearch",
      data: params,
    });
  }
}

export default new LeXiangService();
